import React from 'react';
// Libs
import events from '../../lib/events.js';

// Page object
class printable extends React.Component {
  state = {
    display: null,
  };

  componentDidMount() {
    // Subscribe to events
    this._eventPrint = events.subscribe('print', this.doPrint);
  }

  componentDidUpdate() {
    if (this.state.display) {
      setTimeout(() => window.print(), 100);
    }
  }

  componentWillUnmount() {
    this._eventPrint.remove();
  }

  _eventPrint = null;

  doPrint = (data) => {
    this.setState({display: data});
  };

  render() {
    return (
      <div className='visible-print-block'>
        {this.state.display}
      </div>
    );
  }
}

export default printable;
